export const parseProductResponse = (data: Record<string, any>) => {
   const { cover_image, images, ...details } = data;
   details.default_cover_image = cover_image;
   details.default_images = images;

   details.location_longitude = Number(details.location_longitude);
   details.locationـlatitude = Number(details.locationـlatitude);

   if (details.duration_unit === 'minutes') {
      details.minutes = String(details.duration % 60);

      const h = Math.floor(details.duration / 60);
      details.hours = h < 10 ? `0${h}` : String(h);
   } else details.days = data.duration;

   return details;
};
